
export const yes_no_array =
    [
        { name: 'Yes' },
        { name: 'No' },
    ]
export const debit_credit_array =
    [
        { name: 'Dr' },
        { name: 'Cr' },
    ]
export const nature_of_group_arrya =
    [
        { name: 'Assets' },
        { name: 'Income' },
        { name: 'Expenses' },
        { name: 'Liabilities' }
    ]

export const applicable_not_applicable_array =
    [
        { name: 'Not Applicable' },
        { name: 'Appropriate by Qty' },
        { name: 'Appropriate by Value' },
    ]
export const availlable_array =
    [
        { name: 'Available' },
        { name: 'Not Available' },
    ]



export const applicable_is_or_not =
  [
    { name: 'Applicable' },
    { name: 'Not Applicable' },
  ]
// const yes_no_array =
//   [
//     { name: 'Yes' },
//     { name: 'No' },
//   ]
// const taxability_array =
//   [
//     { name: 'Exempt' },
//     { name: 'Nill Rated' },
//     { name: 'None-Gst' },
//     { name: 'Taxable' },
//   ]
// const hsn_detail_gst_rate_array =
//   [
//     { name: 'As per Company/Stock Group' },
//     { name: 'Specify Details Here' },
//     { name: 'Specify in Voucher' },
//   ]
// const type_of_supply_array =
//   [
//     { name: 'Capital Goods' },
//     { name: 'Goods' },
//     { name: 'Services' },
//   ]
// const costing_method_array =
//   [
//     { name: 'At Zero Cost' },
//     { name: 'Avg Cost' },
//     { name: 'FIFO' },
//     { name: 'FIFO Perpetual' },
//     { name: 'Last Purchase Cost' },
//     { name: 'LIFO Annual' },
//     { name: 'LIFO Perpetual' },
//     { name: 'Monthly Avg Cost' },
//     { name: 'STD Cost' },
//   ]
// const market_valuation_array =
//   [
//     { name: 'At Zero Price' },
//     { name: 'Avg Price' },
//     { name: 'Last Sale Price' },
//     { name: 'STD Price' },
//   ]
// const cess_valuation_array =
//   [
//     { name: 'Not Applicable' },
//     { name: 'Based on Quantity' },
//     { name: 'Based on Value' },
//     { name: 'Based on Qty & Value' },
//   ]

export const dummy_units_array = [
  { id: 1, name: 'PCS', formal_name: 'Pieces' },
  { id: 2, name: 'KG', formal_name: 'Kilogram' },
  { id: 3, name: 'MTR', formal_name: 'Meter' },
  { id: 4, name: 'LTR', formal_name: 'Liter' },
  { id: 5, name: 'BOX', formal_name: 'Box' },
  { id: 6, name: 'BAG', formal_name: 'Bag' },
  { id: 7, name: 'DOZ', formal_name: 'Dozen' },
  { id: 8, name: 'PAIR', formal_name: 'Pair' },
  { id: 9, name: 'SET', formal_name: 'Set' },
  { id: 10, name: 'UNIT', formal_name: 'Unit' },
]
export const voucher_number_periodicity_array = [
  { name: 'Yearly' },
  { name: 'Monthly' },
  { name: 'Never' },
]
